// UI
export const UI_SIDEBAR = "ui/sidebar";
export const UI_SIDEBAR_SELECTED_ITEM = "ui/sidebar_selected_item";

//AUTH

//login
export const ME_FETCH = "me/fetch";
export const ME_FETCH_USER = "me/fetch_user";
export const ME_LOGIN = "me/login";
export const ME_SENDING_DATA = "me/loading_true";
export const ME_LOGIN_ERROR_MESSAGE = "me/error_message";
export const ME_LOADING_STOP = "me/loading_false";
export const ME_UPDATE = "me/update";
export const ME_UPDATE_LOADING = "me/update_loading";

//details-check
export const CHECK_DETAILS = "check/details";
export const SAVE_CHECK_DETAIL_STATUS = "check/status";
export const IS_CHECK_RESPONSE_RECEIVED = "check/response_received";

//signup
export const ME_SIGNUP = "me/signup";
export const ME_SIGNUP_LOADING = "me/signup_loading";
export const ME_SIGNUP_ERROR_MESSAGE = "me/signup_message";

//users
export const USERS_FETCHING = "users/fetch";
export const USERS_FETCHING_COMPLETED = "users/fetch_complete";
export const USER_LIST_RECEIVED = "user/list_received";

export const USER_FETCH_ONE = "user/fetch_one";
export const USER_FETCH_ONE_COMPLETE = "user/fetch_one_complete";
export const USER_FETCH_ONE_ERROR = "user/fetch_one_error";

//groups
export const GROUP_QUERY_CHANGED = "query/change";
export const GROUPS_QUERY_COMPLETED = "groups/fetch";

//group one
export const GROUP_FETCH_ONE = "groups/fetch_one";
export const GROUP_FETCH_ONE_COMPLETED = "groups/fetch_one_completed";
export const GROUP_FETCH_ONE_ERROR = "groups/fetch_one_error";

//sidebar
export const SIDEBAR_STATUS = "sidebar/open";

// trainee
export const BULK_TRAINEE_SEND = "trainee/bulk_send";
export const BULK_TRAINEE_LOADING = "trainee/bulk_loading";
export const BULK_TRAINEE_ERROR_MESSAGE = "trainee/bulk_error_message";
export const TRAINEE_FETCH = "trainee/fetch";
export const TRAINEE_LOAD_DATA_LOADING = "trainee/load_data_loading";
export const TRAINEE_LOAD_DATA_ERROR = "trainee/load_data_error";
export const TRAINEE_FETCH_DATA = "trainee/fetch_data";

// assignment
export const ASSIGNMENT_UPLOAD = "assignment/upload";
export const ASSIGNMENT_UPLOAD_LOADING_ONE = "assignment/upload_loading_one";
export const ASSIGNMENT_UPLOAD_ERROR = "assignment/upload_error";
export const ASSIGNMENT_SAVE = "assignment/save";
export const ASSIGNMENT_FETCH = "assignment/fetch";
export const ASSIGNMENT_FETCH_SAVE = "assignment/fetch_save";
export const ASSIGNMENT_FETCH_LOADING_LIST = "assignment/fetch_loading_list";
export const ASSIGNMENT_FETCH_ERROR = "assignment/fetch_error";
export const ASSIGNMENT_FETCH_AVAILABLE = "assignment/fetch_available";
export const ASSIGNMENT_SUBMIT = "assignment/submit";
export const ASSIGNMENT_SUBMIT_LOADING = "assignment/submit_loading";
export const ASSIGNMENT_SUBMIT_ERROR = "assignment/submit_error";
export const ASSIGNMENT_SUBMIT_FETCH = "assignment/fetch";
export const ASSIGNMENT_SUBMIT_DATA = "assignment/fetch_data";
export const ASSIGNMENT_SUBMIT_FETCH_LOADING = "assignment/fetch_loading";
export const ASSIGNMENT_SUBMIT_FETCH_ERROR = "assignment/fetcg_error";
